import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import { ColorV2 } from "config/colors";

export const COMPANY_AUTH_PRIMARY_BUTTON_STYLES: Partial<BaseButtonStyle> = {
  backgroundColor: ColorV2.PositiveGreen,
  hoverBackgroundColor: ColorV2.SimflexityGreen,
  activeBackgroundColor: ColorV2.SimflexityGreen,
  disabledBackgroundColor: ColorV2.ProgressCompleted,
  disabledTextColor: ColorV2.White,
  disabledBorderColor: "transparent",
};

export const COMPANY_AUTH_SECONDARY_BUTTON_STYLES: Partial<BaseButtonStyle> = {
  ...COMPANY_AUTH_PRIMARY_BUTTON_STYLES,
  textColor: ColorV2.White,
  borderColor: "transparent",
  iconColor: ColorV2.White,
  disabledIconColor: ColorV2.White,
};
